/**
 * en-GB messages added by Phase 2 task M1 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m1EnGB = {
    'error.no_connection': 'No connection. Please check your signal and try again.',
    'error.server': 'Something went wrong on our side. Please try again in a moment.',
    'error.request_failed': 'That did not work. Please try again.',
    'companion.lock.prompt': 'Unlock CloudSign',
    'companion.lock.pin_invalid': 'A PIN must be 4 to 6 digits.',
    'companion.link.invalid': 'This link has expired or is no longer valid.',
    'companion.link.working': 'Signing you in...',
    'companion.push.unavailable': 'Notifications are not available in this version of the app yet.',
    'companion.push.denied': 'Notifications are turned off for this app on your phone.',
};
//# sourceMappingURL=m1.js.map